var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { r as registerInstance, c as createEvent, h, g as getElement } from './core-6f498fd9.js';
import { C as CsmToastSeverity, a as CsmToastClosingType } from './csm-toast.constants-1f59b2c9.js';
var CsmToast = /** @class */ (function () {
    function class_1(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Set the display time of the toast (in milliseconde)
         */
        this.timeout = 10000;
        /**
         * Set the level of severity for the toast
         * default value 'info'
         * possible value 'error', 'warning', 'success', 'info'
         */
        this.severity = CsmToastSeverity.Info;
        /**
         * Set to true to not have display none when hidden
         */
        this.disableHide = false;
        /**
         * Set to true to reset the timeout when the user hovers on the element
         */
        this.pauseOnHover = false;
        /**
         * Set to true to display the close icone inside the toast
         */
        this.displayCloseIcon = true;
        /**
         * Reflects the state of the toast.
         */
        this.showToast = false;
        this.csmClose = createEvent(this, "csmClose", 7);
    }
    /**
     * Display the toast. <br/>
     * The method is async, but you can safely ignore the promise.
     */
    class_1.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                clearTimeout(this.setTimeoutRef);
                this.showToast = true;
                this.startCount();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Close the toast. <br/>
     * The method is async, but you can safely ignore the promise.
     */
    class_1.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.closeToast(CsmToastClosingType.ByCloseMethod);
                return [2 /*return*/];
            });
        });
    };
    class_1.prototype.closeToast = function (closeBy) {
        this.clearTimeout();
        this.showToast = false;
        this.csmClose.emit(closeBy);
    };
    class_1.prototype.startCount = function () {
        var _this = this;
        this.setTimeoutRef = setTimeout(function () {
            _this.closeToast(CsmToastClosingType.ByTimeout);
        }, this.timeout);
    };
    class_1.prototype.clearTimeout = function () {
        clearTimeout(this.setTimeoutRef);
    };
    class_1.prototype.onMouseEnter = function () {
        if (!this.pauseOnHover) {
            return;
        }
        this.clearTimeout();
    };
    class_1.prototype.onMouseLeave = function () {
        if (!this.pauseOnHover) {
            return;
        }
        this.startCount();
    };
    class_1.prototype.render = function () {
        var _this = this;
        return (h("div", { class: { toast: true, 'toast--open': this.disableHide || this.showToast }, onMouseEnter: function () { return _this.onMouseEnter(); }, onMouseLeave: function () { return _this.onMouseLeave(); } }, h("div", { class: "toast__container" }, h("div", { class: "toast__block", "data-severity": this.severity }), h("div", { class: "toast__content" }, h("slot", null))), this.displayCloseIcon && (h("csm-icon", { class: "toast__close-button", name: "close", onClick: function () { return _this.closeToast(CsmToastClosingType.ByUser); } }))));
    };
    Object.defineProperty(class_1.prototype, "toast", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_1, "style", {
        get: function () { return "\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:400;src:url(../assets/fonts/ProximaNova-Regular.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Regular.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:600;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:700;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:900;src:url(../assets/fonts/ProximaNova-Black.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Black.woff) format(\"woff\")}\@font-face{font-family:CS-FontIcon-v19;src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb);src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb#iefix) format(\"embedded-opentype\"),url(../assets/icons/CS-FontIcon-v19.ttf?cz1hbb) format(\"truetype\"),url(../assets/icons/CS-FontIcon-v19.woff?cz1hbb) format(\"woff\"),url(../assets/icons/CS-FontIcon-v19.svg?cz1hbb#CS-FontIcon-v18) format(\"svg\");font-weight:400;font-style:normal;font-display:block}:root{font-family:Proxima Nova,sans-serif}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:inherit}:host{position:fixed;top:88px;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%);z-index:70}.toast{display:none;min-width:240px;max-width:448px;width:100%;padding:12px 16px;background-color:#2a2b2d;color:#fff;-webkit-box-shadow:0 1px 8px rgba(0,0,0,.08),0 5px 22px rgba(0,0,0,.08),0 12px 17px rgba(0,0,0,.1);box-shadow:0 1px 8px rgba(0,0,0,.08),0 5px 22px rgba(0,0,0,.08),0 12px 17px rgba(0,0,0,.1);border-radius:4px}.toast--open,.toast__container{display:-ms-flexbox;display:flex}.toast__container{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex:1 1 100%;flex:1 1 100%}.toast__block{height:100%;width:4px;margin-right:16px}.toast__block[data-severity=success]{background-color:#57d9c0}.toast__block[data-severity=warning]{background-color:#ffc66b}.toast__block[data-severity=error]{background-color:#d94c62}.toast__block[data-severity=info]{background-color:#4b8ae7}.toast__close-button{display:block;width:16px;cursor:pointer}.toast__content{-ms-flex:1;flex:1}"; },
        enumerable: true,
        configurable: true
    });
    return class_1;
}());
export { CsmToast as csm_toast };
